module.exports = "<div class=\"payment-page\">\n  <div class=\"payment-text\">\n    Votre paiement a échoué.  <i class=\"fa fa-times\"></i>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/payment/canceled/payment-canceled.component.html
// module id = 268
// module chunks = 0